import "./src/styles/global.css"
import { wrapPageElement as wrap} from "./src/gatsby/wrapPageElement";

export const wrapPageElement = wrap

export const onClientEntry = () => {
  const hasVisited = sessionStorage.getItem('language-detected');
  
  if (!hasVisited) {
    const browserLang = navigator.language || navigator.userLanguage;
    const langCode = browserLang.split('-')[0];
    
    const currentPath = window.location.pathname;
    
    const isOnRoot = currentPath === '/' || currentPath === '';
    const isOnPolishPage = currentPath.startsWith('/pl/') || currentPath.startsWith('/pl');
    
    if (langCode === 'pl' && isOnRoot) {
      sessionStorage.setItem('language-detected', 'true');
      window.location.replace('/pl/');
    }

    else if (langCode !== 'pl' && isOnPolishPage && isOnRoot) {
      sessionStorage.setItem('language-detected', 'true');
    }

    else {
      sessionStorage.setItem('language-detected', 'true');
    }
  }
}
